const Number = [];

const isPayment = localStorage.getItem('userPayment');

let i;

if (isPayment) {
  i = 1;
} else {
  i = 0;
}

for (i; i <= 200; i++) {
  Number.push({
    quizNo: i,
    name: 'Quiz',
  });
}

export default Number;